export default __webpack_public_path__ + "static/media/include_13_male@3x.4d91c597.jpg";